import React, { useEffect, useState } from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import banner from "../../../assets/kangaroo/AboutBanner.png"
import img1 from "../../../assets/kangaroo/Education.png"
import img2 from "../../../assets/kangaroo/QEAC.png"
import img3 from "../../../assets/kangaroo/britishcouncil.png"
import img4 from "../../../assets/kangaroo/ITAC.png"
import img5 from "../../../assets/kangaroo/USATC.png"
import img6 from "../../../assets/kangaroo/Canada Course.png"
import img7 from "../../../assets/kangaroo/NZEAC.png"
import idp from "../../../assets/kangaroo/IELTS.png"
import bupa from "../../../assets/kangaroo/BUPA.png"
import nib from "../../../assets/kangaroo/NIB.png"
import aus from "../../../assets/kangaroo/Australian.png"
import media from "../../../assets/kangaroo/medibank.png"
import { Col, Container, Row } from 'reactstrap'
import Professional from '../../../Homepage/Professional'
import { useLocation } from 'react-router-dom'
import PageService from '../../../services/PageService'
import { imageBaseApi } from '../../../services/imageBaseApi'


const AboutPartner = () => {

   const location = useLocation();
   const path = location?.pathname?.split("/")?.filter(Boolean).pop();

    const [detailData, setDetailData] = useState()
  const fetchDetail = async () => {
    try {
      const response = await PageService.getbySlug(path);
      setDetailData(response)
    } catch (error) {
      console.log(error);

    }
  }

   useEffect(() => {
      fetchDetail()
    }, [location])

  const ProfImage = [
  { src: img1, alt: "Education Certification" },
  { src: img2, alt: "QEAC" },
  { src: img3, alt: "British Council" },
  { src: img4, alt: "ITAC" },
  { src: img5, alt: "USATC" },
  { src: img6, alt: "Canada Course" },
  { src: img7, alt: "NZEAC" },
];
const IeltsImage = [
    { src: img3, alt: "Education Certification" },
  { src: idp, alt: "IELTS" },
]
const InsuranceImage = [
  { src: bupa, alt: "BUPA" },
  { src: nib, alt: "NIB" },
  { src: aus, alt: "Australian" },
  { src: media, alt: "Media Bank" },

]
const pathimg = detailData && imageBaseApi + detailData?.featuredMedia?.url
console.log(pathimg)
  return (
    <div>
       <div className='about-hero-banner'  style={{ backgroundImage:`url(${pathimg})`, marginBottom: "5.5rem"  }}>
        <SectionContainer>
          <BreadCrumb items={[
    { title: "HOME", link: "/" },
    { title: "ABOUT", link: "#" },
    { title: "PARTNERSHIPS" },
    
  ]}instituition={true}  />
  <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
   <h1 className='font-level-4 lh-1' >ACCREDITATIONS & <br /> PARTNERSHIPS</h1>
  </div>
        </SectionContainer>

      </div>
      <SectionContainer>
        {/* <Container fluid style={{marginBottom:"24.7rem"}}>
          <Row>
            <Col className='p-0'>
            <p className='about-subheading '>PROFESSIONAL CERTIFICATION:</p>
            </Col>
          </Row>
          <Row className="justify-content-start g-3 about-map g-md-4">
  {ProfImage.map((item, index) => (
    <Col
      key={index}
      xs={6}
      sm={6}
      md={4}
      lg={3}
      className="d-flex justify-content-start px-2 px-md-3 border m-0"
    >
      <img src={item.src} alt={item.alt} className="img-fluid" />
    </Col>
  ))}
</Row>
<Row>
  <Col className='p-0'>
  <p className='about-subheading'>IELTS PARTNERS:</p></Col>
</Row>
<Row className="justify-content-start g-3 g-md-4  about-map">
  {IeltsImage.map((item, index) => (
    <Col
      key={index}
      xs={6}
      sm={6}
      md={4}
      lg={3}
      className="d-flex justify-content-start px-2 px-md-3 border m-0"
    >
      <img src={item.src} alt={item.alt} className="img-fluid" />
    </Col>
  ))}
</Row>
<Row>
  <Col className='p-0'>
  <p className='about-subheading'>INSURANCE PARTNERS:</p>
  </Col>
</Row>
<Row className="justify-content-start g-3 g-md-4">
  {InsuranceImage.map((item, index) => (
    <Col
      key={index}
      xs={6}
      sm={6}
      md={4}
      lg={3}
      className="d-flex justify-content-start px-2 px-md-3 border m-0"
    >
      <img src={item.src} alt={item.alt} className="img-fluid" />
    </Col>
  ))}
</Row>

        </Container> */}
        <Professional about={false} aboutPartner={true} />
      </SectionContainer>
      
    </div>
  )
}

export default AboutPartner
